import { useAtom } from 'jotai'
import { currentActionAtom } from '../../stores/atom'

export const useCurrentAction = () => {
  const [currentActionGlobal, setCurrentActionGlobal] = useAtom(currentActionAtom)

  return {
    currentActionGlobal,
    setCurrentActionGlobal
  }
}
